export default "__VITE_ASSET__CaHU$GBh__";